module.exports = __webpack_public_path__ + "img/maintenance5.475b0f51.png";